import KanbanBoard from './KanbanBoard.vue';

export const routes = [
  {
    path: 'kanban',
    name: 'kanban_dashboard',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: KanbanBoard,
  },
  {
    path: 'kanban/:attributeKey',
    name: 'kanban_board',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: KanbanBoard,
  },
];
